import { useEffect, useState, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
const we_next_logo = '/assets/wenext_logo_dark.png';

const AUTH_SLIDES = [
  {
    img: '/onboardingimg/image1.png',
    title: 'Integrate your favorite tools',
    subtitle: 'Connect Shopify, Zapier, Webflow, Stripe and more — bring your whole stack into one platform.',
    imgClassName: 'scale-[0.94]',
  },
  {
    img: '/onboardingimg/image2.png',
    title: 'Build automations without code',
    subtitle: 'Design conversation flows with keywords, conditions, and instant replies on a visual builder.',
  },
  {
    img: '/onboardingimg/image3.png',
    title: 'Run every channel from one hub',
    subtitle: 'Manage Facebook, Instagram, LinkedIn, Meta Ads, and WhatsApp campaigns — all from WeNext.',
  },
];

export function AuthShell({ children }: { children: ReactNode }) {
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSlide((s) => (s + 1) % AUTH_SLIDES.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen w-full bg-white lg:grid lg:h-screen lg:grid-cols-2 lg:overflow-hidden">
      <div className="relative hidden overflow-hidden lg:flex lg:pl-6 lg:pt-6 lg:pb-6">
        <div
          className="relative flex flex-1 flex-col items-center justify-center overflow-hidden rounded-3xl p-12"
          style={{ background: 'linear-gradient(160deg, #17a866 0%, #0c8a4f 45%, #0a6a3d 100%)' }}
        >
        <div className="relative z-10 flex w-full max-w-lg flex-col items-center">
          <div className="relative aspect-[4/3] w-full">
            {AUTH_SLIDES.map((s, i) => (
              <img
                key={s.img}
                src={s.img}
                alt=""
                aria-hidden={i !== slide}
                className={cn(
                  'absolute inset-0 h-full w-full rounded-2xl object-contain transition-opacity duration-700 ease-out',
                  (s as { imgClassName?: string }).imgClassName,
                  i === slide ? 'opacity-100' : 'opacity-0'
                )}
              />
            ))}
          </div>

          <div key={slide} className="animate-in fade-in duration-700">
            <h2 className="mt-10 text-center text-3xl font-extrabold leading-tight text-white">
              {AUTH_SLIDES[slide].title}
            </h2>
            <p className="mt-3 mx-auto max-w-md text-center text-sm leading-relaxed text-white/80">
              {AUTH_SLIDES[slide].subtitle}
            </p>
          </div>

          <div className="mt-6 flex items-center gap-2">
            {AUTH_SLIDES.map((_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`Go to slide ${i + 1}`}
                onClick={() => setSlide(i)}
                className={cn(
                  'h-1.5 rounded-full transition-all duration-300',
                  i === slide ? 'w-6 bg-white' : 'w-1.5 bg-white/40 hover:bg-white/60'
                )}
              />
            ))}
          </div>
        </div>
        </div>
      </div>

      <div className="flex min-h-screen flex-col bg-white px-6 py-10 sm:px-10">
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center">
          <img src={we_next_logo} alt="wenext" className="mb-8 w-[132px]" />
          {children}
        </div>
      </div>
    </div>
  );
}
